import ReactTooltip from 'react-tooltip'
import React from 'react'
import * as styles from './index.module.css'

const Tooltip = ({ content }) => {
  return (
    <>
      <svg
        style={{
          width: '11px',
          height: '11px',
          margin: '0 0 0 10px',
          cursor: 'pointer',
        }}
        data-for="tooltip"
        data-event="click"
        data-tip={content}
        data-html={true}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 11 11"
      >
        <defs></defs>
        <circle
          style={{ fill: 'none', stroke: '#5e79fb' }}
          cx="5.5"
          cy="5.5"
          r="5"
        />
        <path
          style={{ fill: '#5e79fb' }}
          d="M4.92,6.75h.71v-.3a.87.87,0,0,1,.48-.78l.41-.29a1.52,1.52,0,0,0,.82-1.3c0-.85-.64-1.44-1.73-1.44A1.78,1.78,0,0,0,3.66,4.49l.78.08c0-.89.51-1.21,1.14-1.21s1,.28,1,.74a1,1,0,0,1-.59.84l-.33.22a1.38,1.38,0,0,0-.69,1.21Zm.85.6h-1v1h1Z"
        />
      </svg>
      <ReactTooltip
        id="tooltip"
        place="bottom"
        effect="solid"
        globalEventOff="click"
        className={styles.tooltip}
        html={true}
        getContent={(content) => {
          return `<div style="position: relative">
              <svg
                style="position: absolute; top: -11px; right: -11px; cursor: pointer;"
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onclick="this.parentNode.parentNode.classList.remove('show')"
              >
                <path
                  d="M2.01041 0.596191L12.617 11.2028L11.2028 12.617L0.596192 2.0104L2.01041 0.596191Z"
                  fill="white"
                />
                <path
                  d="M12.617 2.0104L2.0104 12.617L0.596191 11.2028L11.2028 0.596191L12.617 2.0104Z"
                  fill="white"
                />
              </svg>
              <div class="${styles.innerTooltip}" style="width: 80%;">
                ${content}
              </div>
            </div>`
        }}
      />
    </>
  )
}

export default Tooltip
